import axios from 'axios';
import * as constants from 'Constants';
import * as utils from 'Utils';


//===================================================
// API Utils
//===================================================
export function handleErrorCallback(error, errorCallback) {
  if (error.response) {
    if (error.response.status === 500) {
      errorCallback("Server error 500. This error indicates that there are some issues on our end.");
      return;
    }

    if (error.response.data) {
      if (error.response.data.errors && Array.isArray(error.response.data.errors)) {
        errorCallback(error.response.data.errors.join("\n"));
        return;
      }

      errorCallback(error.response.data);
      return;
    }
  }

  errorCallback(error.message);
}

export function handleRqSuccess(response, successCallback) {
  successCallback(response.data);
};


export function handleRqError(error, errorCallback) {
  handleErrorCallback(error, errorCallback);
};


export function getRq(kwargs) {
  const config = {};
  config['method'] = 'get';
  config['url'] = kwargs.url;
  if (kwargs.headers) config['headers'] = kwargs.headers;

  axios(config)
    .then((response) => handleRqSuccess(response, kwargs.successCallback))
    .catch((error) => handleRqError(error, kwargs.errorCallback));
};

export function postRq(kwargs) {
  const config = {};
  config['method'] = 'post';
  config['url'] = kwargs.url;
  config['data'] = kwargs.data || "{}";
  if (kwargs.headers) config['headers'] = kwargs.headers;

  axios(config)
    .then((response) => handleRqSuccess(response, kwargs.successCallback))
    .catch((error) => handleRqError(error, kwargs.errorCallback));
};

export function buildUrl(path, qs={}) {
  return utils.appendQueryString(`${BASE_API_URL}/${constants.API_VERSION}/${path}`, qs);
}


//=================================================
// Endpoints
//=================================================
export function getViewIntegrations(successCallback, errorCallback, qs={}) {
  getRq({
    "url": buildUrl(`integrations`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewIntegrationDetails(successCallback, errorCallback, integrationId) {
  getRq({
    "url": buildUrl(`integration-details/${integrationId}`),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


export function getViewAgencies(successCallback, errorCallback, qs={}) {
  getRq({
    "url": buildUrl(`agencies`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewAgencyDetails(successCallback, errorCallback, agencyId) {
  getRq({
    "url": buildUrl(`agency-details/${agencyId}`),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


